<template>
  <el-dialog :visible.sync="visible" custom-class="full-dialog" title="拆单发货" :close-on-click-modal="false" @close="closeDialog" center :append-to-body="true">
    <div class="split-print-container">
      <div class="split-print-body">
        <div class="split-print-panel panel-left">
          <div class="panel-title"><span class="panel-title-text">发货单</span></div>
          <CstagreementEdit ref="leftEdit" :no-modal="true" :append-to-body="false" custom-class="split-embed-dialog" />
        </div>
        <div class="split-print-panel panel-right">
          <div class="panel-title"><span class="panel-title-text">缺货单</span><el-button type="danger" size="mini" @click="closeDialog" style="margin-right:8px;">关闭</el-button></div>
          <CstagreementEdit ref="rightEdit" :no-modal="true" :append-to-body="false" :show-only-print-outstock="true" custom-class="split-embed-dialog" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SplitOrderPrint',
  components: {
    CstagreementEdit: () => import('./CstagreementEdit')
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    initEmbedEdit(refName, row) {
      if (this.$refs[refName]) {
        this.$refs[refName].initData(row, '', '', '')
        this.$refs[refName].show()
        return true
      }
      return false
    },
    show(newRow, originalRow) {
      this.visible = true
      this.$nextTick(() => {
        var leftDone = newRow ? this.initEmbedEdit('leftEdit', newRow) : true
        var rightDone = originalRow ? this.initEmbedEdit('rightEdit', originalRow) : true
        // 如果异步组件还没加载完，轮询等待
        if (!leftDone || !rightDone) {
          var timer = setInterval(() => {
            if (newRow) {
              //已初始化的实例避免重复 initData，防止每次 initForm() 清空数据并重复请求
              if (!leftDone) leftDone = this.initEmbedEdit('leftEdit', newRow)
            } else {
              leftDone = true
            }
            if (originalRow) {
              if (!rightDone) rightDone = this.initEmbedEdit('rightEdit', originalRow)
            } else {
              rightDone = true
            }
            if (leftDone && rightDone) {
              clearInterval(timer)
            }
          }, 100)
        }
      })
    },
    closeDialog() {
      this.visible = false
      if (this.$refs.leftEdit) this.$refs.leftEdit.dialogSeeVisible = false
      if (this.$refs.rightEdit) this.$refs.rightEdit.dialogSeeVisible = false
    }
  }
}
</script>

<style scoped>
.split-print-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.split-print-body {
  flex: 1;
  display: flex;
  overflow: hidden;
}
.split-print-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: #fff;
}
.panel-left {
  border-right: 2px dashed #dcdfe6;
}
.panel-title {
  display: flex;
  align-items: center;
  font-size: 14pt;
  font-weight: bold;
  line-height: 44px;
  border-bottom: 2px solid #333;
  flex-shrink: 0;
  background: #fafafa;
}
.panel-title-text {
  flex: 1;
  text-align: center;
}
</style>

<!-- 全局样式：覆盖内嵌 CstagreementEdit 的 el-dialog 定位，避免浮于上层 -->
<style>
.split-print-panel .el-dialog__wrapper {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  width: 100% !important;
  flex: 1 !important;
  min-height: 0 !important;
}
.split-print-panel .el-dialog {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  position: relative !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
  border-radius: 0;
}
.split-print-panel .el-dialog__body {
  padding: 10px 15px;
  overflow: visible;
}
.split-print-panel .el-dialog__header {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/SplitOrderPrint.vue